import Base from './base'

export default class Feedback extends Base {
  create(data: FormData) {
    return this.apiClient.post('/feedback', data)
  }

  followUps(data: {
    title: string
    description: string
    pageUrl?: string
    screenshotData?: string
  }) {
    return this.apiClient.post('/feedback/follow-ups', data)
  }

  list(params = {}) {
    return this.apiClient.get('/feedback', params)
  }

  addInfo(data: { id: string; text: string }) {
    return this.apiClient.post('/feedback/add-info', data)
  }

  listSubmitters() {
    return this.apiClient.get('/feedback/submitters')
  }

  listFiles(id: string) {
    return this.apiClient.get(`/feedback/${id}/files`)
  }

  createTicket(id: string) {
    return this.apiClient.post(`/feedback/${id}/ticket`)
  }
}
